"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  dangerouslySetInnerHTML: {
    __html: "<path d=\"M7.024 5.268A10.32 10.32 0 0112 4c4.937 0 9.055 3.436 10 8a9.832 9.832 0 01-1.429 3.428L16 12a4 4 0 00-5.121-3.84L7.024 5.267z\" fill=\"#000\"></path><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M22.08 19.56L1.44 4.08 0 6l3.429 2.572A9.832 9.832 0 002 12c.945 4.564 5.063 8 10 8 1.807 0 3.504-.46 4.976-1.268l3.664 2.748 1.44-1.92zM8 12l5.121 3.84A4.003 4.003 0 018 12z\" fill=\"#000\"></path>"
  },
  viewBox: "0 0 24 24",
  fill: "none"
};
exports["default"] = _default;